export const CREATE_NEW_CHAT_CONVERSATION_REQUEST = 'CREATE_NEW_CHAT_CONVERSATION_REQUEST';

export const createNewChatConversationRequest = ({ pseudonym, initialMessage, subject }) => ({
    type: CREATE_NEW_CHAT_CONVERSATION_REQUEST,
    payload: {
        subject,
        pseudonym,
        initialMessage,
    },
});
